import { Injectable, signal } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class LoaderService {
  skipLoader = false;
  isLoading = signal(false);
}
